import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["pattern", "testInput", "resultText", "resultStatus"];
  static values = { defaultTest: String };

  connect() {
    this.defaultTestValue = "TestDefektFile.txt";
    this.updateResult();
  }

  updateResult() {
    let pattern = this.patternTarget.value;
    const testText = this.testInputTarget.value || this.defaultTestValue;
    
    try {
      const regex = new RegExp(pattern, 'i'); // Always use case-insensitive flag
      const matches = regex.test(testText);
      
      this.resultTextTarget.textContent = testText;
      this.resultTextTarget.classList.remove("text-green-600", "text-red-600");
      this.resultStatusTarget.classList.remove("text-green-600", "text-red-600");
      
      if (matches) {
        this.resultTextTarget.classList.add("text-green-600");
        this.resultStatusTarget.textContent = "Ja, trifft";
        this.resultStatusTarget.classList.add("text-green-600");
      } else {
        this.resultTextTarget.classList.add("text-red-600");
        this.resultStatusTarget.textContent = "Nein, trifft nicht";
        this.resultStatusTarget.classList.add("text-red-600");
      }
    } catch (e) {
      this.resultTextTarget.textContent = testText;
      this.resultStatusTarget.textContent = "Ungültiges Muster";
      this.resultTextTarget.classList.remove("text-green-600", "text-red-600");
      this.resultStatusTarget.classList.remove("text-green-600", "text-red-600");
      this.resultStatusTarget.classList.add("text-red-600");
    }
  }

  testPattern(event) {
    this.updateResult();
  }
}